export default "__VITE_ASSET__Q4cS79Oo__"